const subtopicsSagaNamespace = 'subtopics';
export const LOAD_SUBTOPICS_BY_RATE = `${subtopicsSagaNamespace}/LOAD_SUBTOPICS_BY_RATE`;
export const UPDATE_CHAPTER_SUBTOPICS = `${subtopicsSagaNamespace}/UPDATE_CHAPTER_SUBTOPICS`;
export const LOAD_RATE = `${subtopicsSagaNamespace}/LOAD_RATE`;
export const LOAD_CHAPTERS_BY_RATE = `${subtopicsSagaNamespace}/LOAD_CHAPTERS_BY_RATE`;
export const UPDATE_SUBTOPIC_CHAPTERS = `${subtopicsSagaNamespace}/UPDATE_SUBTOPIC_CHAPTERS`;
